import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page center" }
const _hoisted_2 = { class: "is-size-3" }
const _hoisted_3 = { class: "button" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('not_found.title')), 1 /* TEXT */),
    _createVNode(_component_router_link, {
      to: { name: 'dashboard', params: { group: _ctx.group?.name || 'default'}}
    }, {
      default: _withCtx(() => [
        _createElementVNode("button", _hoisted_3, _toDisplayString(_ctx.$t('dashboard.back_to_dashboard')), 1 /* TEXT */)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["to"])
  ]))
}